import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface SiteSetting {
  key: string;
  value: string;
  label: string;
}

export type SiteSettingsMap = Record<string, string>;

export function useSiteSettings(keys?: string[]) {
  const [settings, setSettings] = useState<SiteSettingsMap>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      let query = supabase.from('site_settings').select('key, value, label');
      if (keys && keys.length > 0) {
        query = query.in('key', keys);
      }
      const { data, error } = await query;
      if (error) throw error;
      const map: SiteSettingsMap = {};
      (data || []).forEach((item) => {
        map[item.key] = item.value || '';
      });
      setSettings(map);
    } catch (error) {
      console.error('Failed to fetch site settings:', error);
    } finally {
      setLoading(false);
    }
  };

  return { settings, loading, refetch: fetchSettings };
}
